var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},_vm._l((_vm.gemeos),function(gemeo,index){return _c('SearchCard',{key:index,staticClass:"mb-3",attrs:{"check":gemeo.check,"data-info":gemeo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }